<template>
  <div>
    <v-title>Audit Logs</v-title>
    <v-spacer></v-spacer>
    <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    <v-data-table
      :headers="headers"
      :items="rows"
      class="elevation-1"
      :pagination.sync="pagination"
      item-key="id"
      :loading="loading"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{props.item.auditDate | formatDate}}</td>
          <td>{{props.item.entityType}}</td>
          <td>
            <vue-json-pretty
              class="pa-0 ma-0"
              path="Changes"
              :data="JSON.parse( props.item.auditData)"
            ></vue-json-pretty>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import globalMixin from "@/mixins/globalMixin";
import VueJsonPretty from "vue-json-pretty";

import { mapActions, createNamespacedHelpers } from "vuex";
import { mapMultiRowFields } from "vuex-map-fields";
import {
  mapAuditFields,
  mapAuditMultiRowFields
} from "@/store/modules/forms/audit";
const { mapActions: mapAuditActions } = createNamespacedHelpers(`orders/audit`);

export default {
  name: "AuditLogs",
  mixins: [globalMixin],
  components: {
    VueJsonPretty
  },
  data() {
    return {
      rows: [],
      headers: [
        {
          text: "Date",
          align: "left",
          sortable: true,
          isDescending: true,
          value: "auditDate"
        },

        {
          text: "EntityType",
          align: "left",
          sortable: true,
          value: "entityType"
        },
        {
          text: "Audit Data",
          align: "left",
          sortable: true,
          value: "auditData"
        }
      ],
      pagination: { sortBy: "Date", descending: true },
      loading: false,
      search: ""
    };
  },
  computed: {
    ...mapAuditFields(["query", "message"])
  },
  methods: {
    ...mapAuditActions(["getAuditLog"])
  },
  mounted() {
    let vm = this;
    vm.getAuditLog().then(data => {
      vm.rows = data;
    });
  }
};
</script>

<style scoped>
</style>